import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import {
  createCollaboratorApi,
  deleteCollaboratorApi,
  fetchCollaboratorById,
  fetchCollaborators,
  updateCollaboratorApi,
} from "../services/collaboratorsService";

const COLLABORATORS_QK = ["collaborators"];

export const useCollaborators = () =>
  useQuery({ queryKey: COLLABORATORS_QK, queryFn: fetchCollaborators });

export const useCollaborator = (id, options = {}) =>
  useQuery({
    queryKey: [...COLLABORATORS_QK, id],
    queryFn: () => fetchCollaboratorById(id),
    enabled: !!id,
    ...options,
  });

export const useCreateCollaborator = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: createCollaboratorApi,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: COLLABORATORS_QK });
      toast.success("Collaborateur ajouté", { autoClose: 3000 });
    },
    onError: () => toast.error("Ajout échoué", { autoClose: 3000 }),
  });
};

export const useUpdateCollaborator = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, payload }) => updateCollaboratorApi(id, payload),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: COLLABORATORS_QK });
      toast.success("Collaborateur modifié", { autoClose: 3000 });
    },
    onError: () => toast.error("Modification échouée", { autoClose: 3000 }),
  });
};

export const useDeleteCollaborator = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: deleteCollaboratorApi,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: COLLABORATORS_QK });
      toast.success("Collaborateur supprimé", { autoClose: 3000 });
    },
    onError: () => toast.error("Suppression échouée", { autoClose: 3000 }),
  });
};
